import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";

import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";

function Problem(props) {
  const [operation, setOperation] = useState(["+", "-", "*", "/"]);
  const [topNum, setTopNum] = useState();
  const [botNum, setBotNum] = useState();
  const [answer, setAnswer] = useState();
  const [questionT, setQuestionT] = useState(false);
  const [rnd, setRnd] = useState(1);
  const [flip, setFlip] = useState(0);
  const [t, setT] = useState(false);
  const [incorrectAnswer, setIncorrectAnswer] = useState();
  //settings
  const [user, setUser] = useState({
    id: "",
    difficulty: 0,
  });

  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    // setUser({
    //   id: response.data[0].id,
    //   difficulty: response.data[0].difficulty,
    // });
  };

  const handleProblem = () => {
    //top number
    let topNumber = 1;
    if (user.difficulty === 0) {
      topNumber = topNumber * 10;
    }
    if (user.difficulty === 1) {
      topNumber = topNumber * 100;
    }
    if (user.difficulty === 2) {
      topNumber = topNumber * 1000;
    }
    topNumber = Math.floor(Math.random() * topNumber);

    //bottom number
    let bottomNumber = 1;
    if (user.difficulty === 0) {
      bottomNumber = 1;
    }
    if (user.difficulty === 1) {
      bottomNumber = 10;
    }
    if (user.difficulty === 2) {
      bottomNumber = 100;
    }
    bottomNumber = Math.floor(Math.random() * bottomNumber);
    let op = operation[rnd];
    if (botNum === 0 && op === "/") {
      setAnswer("Infinity");
    } else {
      let answer = {
        "+": topNumber + bottomNumber,
        "-": topNumber - bottomNumber,
        "*": topNumber * bottomNumber,
        "/": topNumber / bottomNumber,
      };
      setAnswer(answer[op]);

      props.setX(answer[op]);

      setBotNum(bottomNumber);
      setTopNum(topNumber);
    }
    setQuestionT(!questionT);
  };

  const correctOrIncorrect = () => {
    if (flip >= 5) {
      setT(true);
      props.setY(true);
    } else {
      setT(false);
      props.setY(false);
    }
  };

  useEffect(() => {
    handleSettings();
  }, []);

  useEffect(() => {
    setRnd(1 + Math.floor(Math.random() * user.difficulty));
    setFlip(Math.floor(Math.random() * 10));
  }, [props.guess]);

  useEffect(() => {
    if (flip >= 0) {
      handleProblem();
      if (props.choice) {
      } else {
        correctOrIncorrect();
      }
    }
  }, [flip]);

  useEffect(() => {
    if (flip >= 0) {
      let num1 = 0;
      let num2 = 0;
      let num3 = 0;
      if (flip >= 4) {
        setIncorrectAnswer(
          Math.floor(Math.floor(Math.random() * flip) + answer)
        );
      } else {
        setIncorrectAnswer(
          Math.floor(Math.floor(Math.random() * flip) - answer)
        );
      }
      if (flip >= 0 && flip <= 3) {
        num1 = answer;
      } else {
        if (flip >= 4 && flip <= 6) {
          num1 = Math.floor(Math.floor(Math.random() * flip + 1) - answer);
          if (num1 === answer) {
            num1 = num3 - 4;
          }
        } else {
          num1 = Math.floor(Math.floor(Math.random() * flip + 1) + answer);
          if (num1 === answer) {
            num1 = num3 - 4;
          }
        }
      }
      if (flip >= 4 && flip <= 6) {
        num2 = answer;
      } else {
        if (flip <= 3) {
          num2 = Math.floor(Math.floor(Math.random() * flip + 1) + answer);
          if (num2 === answer) {
            num2 = num2 + 4;
          }
        } else {
          num2 = Math.floor(Math.floor(Math.random() * flip + 1) - answer);
          if (num2 === answer) {
            num2 = num2 + 4;
          }
        }
      }
      if (flip >= 7 && flip <= 20) {
        num3 = answer;
      } else {
        if (flip >= 4 && flip <= 6) {
          num3 = Math.floor(Math.floor(Math.random() * flip + 1) + answer);
          if (num3 === answer) {
            num3 = num3 - 4;
          }
        } else {
          num3 = Math.floor(Math.floor(Math.random() * flip + 1) - answer);
          if (num3 === answer) {
            num3 = num3 - 4;
          }
        }
      }
      props.setNumOne(num1);
      props.setNumTwo(num2);
      props.setNumThree(num3);
    }
  }, [questionT]);

  useEffect(() => {
    if (incorrectAnswer === answer) {
      setIncorrectAnswer((prevAnswer) => prevAnswer - 4);
    }
  }, [incorrectAnswer, props]);

  return (
    <>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col style={{ fontSize: "60px" }}>{String(topNum)}</Col>
        <Col style={{ fontSize: "60px" }}>
          {operation[rnd] === "+" && "+"}
          {operation[rnd] === "-" && "-"}
          {operation[rnd] === "*" && "x"}
          {operation[rnd] === "/" && "/"}
        </Col>
        <Col style={{ fontSize: "60px" }}>{String(botNum)}</Col>
        <Col style={{ fontSize: "60px" }}>=</Col>
        <Col style={{ fontSize: "60px" }}>
          {props.choice ? `?` : t ? String(answer) : String(incorrectAnswer)}
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
    </>
  );
}

export default Problem;
